import { getValidAccessToken } from '@declaration/services/accessTokenValidation';
const middleware = async ({ redirect, $axios, store, app: { localePath } }) => {
    const accessToken = await getValidAccessToken($axios, store);
    if (!accessToken)
        return redirect(localePath({ name: 'login' }));
};
export default middleware;
